export const appRouterPaths = {
  dashboards: "/dashboards",
  contacts: {
    base: "/contacts",
    genInfo: "/contacts/generalInfo/:personId?",
    activities: "/contacts/activities/:personId?",
    notes: "/contacts/notes/:personId?",
    connections: "/contacts/connections/:personId?",
    ideas: "/contacts/ideas/:personId?",
    commitments: "/contacts/commitments/:personId?",
  },
  notes: "/notes",
  ideas: "/ideas",
  commitments: "/commitments",
  calendarV2: "/calendar",
  signUp: "/auth/sign-up",
  logIn: "/auth/log-in",
  enterPin: "/auth/enter-pin",
  checkStatus: "/auth/check-status",
  checkPayment: "/auth/check-payment",
  mobilePayments: "/auth/mobile_payment",
  passwordRecovery: "/auth/recovery",
  settings: "/settings",
};
